import React, {useState} from 'react';
import {getFormData, inputChangedHandler, prepareFormData, validateForm} from "../../shared/utility";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import {connect} from "react-redux";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import TextField from "@material-ui/core/TextField";
import {Box} from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import {useHistory} from "react-router-dom";
import * as actions from "../../store/actions";

const useStyles = makeStyles((theme) => ({
    instructions: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#FEFFFF",
        paddingBottom: "16px"
    },
    label: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "flex-end",
        color: "#FEFFFF",
        paddingBottom: "4px"
    },
    formElement: {
        paddingBottom: "8px",
        '& .MuiFormHelperText-contained': {
            marginLeft: "0px",
        },
    },
    buttonProgress: {
        color: green[500],
        marginLeft: theme.spacing(1),
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    input: {
        backgroundColor: "transparent",
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        color: "#FEFFFF"
    },
}));


let formData = {
    controls: {
        mileage: {
            label: 'Mileage',
            value: '',
            validation: {
                presence: {allowEmpty: false},
                numericality: {
                    onlyInteger: true,
                    greaterThanOrEqualTo: 0,
                    lessThan: 1000000
                },
            },
            valid: false,
            touched: false,
            helperText: null,
        },
        vin: {
            label: 'VIN',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                length: { is: 17 },
                format: { pattern: '^[A-HJ-NPR-Z0-9]+[0-9]{5}$', flags: "i", message: "should not contain I’s, O’s, or Q’s, and the last 5 chars should be digits" }
            },
            inputFilter: '[^A-HJ-NPR-Za-hj-npr-z0-9]',
            valid: false,
            touched: false,
            helperText: null,
        },
        titleStatus: {
            label: 'Title Status',
            value: '',
            values: [
                {key: 'Clean', value: "Clean"},
                {key: 'Salvage/Rebuilt', value: "Salvage/Rebuilt"},
                {key: 'Parts Only', value: "Parts Only"},
                {key: 'Unknown', value: "Unknown"},
            ],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
            helperText: null,
            type: "dropdown",

        },

    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}

const Step1 = (props) => {


    const classes = useStyles();
    const [formState, setFormState] = useState(formData);

    const history = useHistory();


    React.useEffect(() => {
        const state = {vin: props.vehicle.vin, mileage: props.vehicle.mileage, titleStatus: props.vehicle.titleStatus}
        formData = prepareFormData(formState, state);
        setFormState(formData);
    }, [null])


    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            const data = getFormData(formState)
            props.onNext(data, nextStep => {
                //props.handleNext()
            })
        }
    }


    const vinField = formState.controls.vin;
    const mileageField = formState.controls.mileage;
    const titleStatusField = formState.controls.titleStatus;

    console.log(props.app)
    return (
        <React.Fragment>

            <Box className={classes.instructions}>Please enter the information bellow to get started:</Box>
            {props.app.error &&
            <div className={classes.wrapper}>
                <Alert severity="error">{props.app.error ?? ''}</Alert>
            </div>
            }
            <Box className={classes.formElement}>
                <Box className={classes.label}>What is the VIN?</Box>
                <TextField
                    name={vinField.key}
                    value={vinField.value}
                    type={'input'}
                    //label={vinField.label}
                    fullWidth
                    margin="dense"
                    onChange={event => inputChangedHandler(formState, setFormState, event.target.value, vinField.key)}
                    helperText={vinField.helperText}
                    error={!vinField.valid && vinField.touched}
                    variant="outlined"
                    InputProps={{
                        className: classes.input,
                    }}
                    placeholder="ex: 5NPE34AF0FH119170"
                />
            </Box>
            <Box className={classes.formElement}>
                <Box className={classes.label}>What is the current mileage of the vehicle?</Box>
                <TextField
                    name={mileageField.key}
                    value={mileageField.value}
                    type={'input'}
                    fullWidth
                    margin="dense"
                    onChange={event => inputChangedHandler(formState, setFormState, event.target.value, mileageField.key)}
                    helperText={mileageField.helperText}
                    error={!mileageField.valid && mileageField.touched}
                    placeholder="ex: 62540"
                    variant="outlined"
                    InputProps={{
                        className: classes.input,
                    }}
                />
            </Box>
            <Box className={classes.formElement}>
                <Box className={classes.label}>What is the Title's Status?</Box>
                <FormControl className={classes.formControl}
                             fullWidth
                             error={!titleStatusField.valid && titleStatusField.touched}
                             margin={"dense"}
                             key={titleStatusField.key}

                >
                    <Select
                        key={titleStatusField.key}
                        labelId="{titleStatusField.key}-label"
                        id={titleStatusField.key}
                        value={titleStatusField.value}
                        displayEmpty
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, titleStatusField.key)}
                        error={!titleStatusField.valid && titleStatusField.touched}
                        margin="dense"
                        variant="outlined"
                        className={classes.input}
                    >
                        <MenuItem value="" className={classes.input}>
                            <em>--Select--</em>
                        </MenuItem>
                        {titleStatusField.values.map((item, i) => (
                            <MenuItem key={titleStatusField.key + i} value={item.key}
                                      className={classes.input}>{item.value}</MenuItem>
                        ))}

                    </Select>
                    <FormHelperText>{!titleStatusField.valid && titleStatusField.touched ? titleStatusField.helperText : ""}</FormHelperText>
                </FormControl>
            </Box>
            <Box display="flex" justifyContent="flex-end" style={{marginTop: '16px', marginBottom: '30px'}}>
                <div className={classes.wrapper}>
                    <Button className={classes.button} type={"button"} variant={"outlined"} onClick={() => {
                        props.onReset()
                        history.push('/dashboard')
                    }}
                    > {props.backButton}</Button>

                    <Button
                        className={classes.button}
                        type={"button"}
                        variant={"contained"}
                        color={"primary"}
                        onClick={submitHandler}
                    >  {props.nextButton}  {props.app.loading &&
                    <CircularProgress size={24} className={classes.buttonProgress}/>}</Button>

                </div>
            </Box>
        </React.Fragment>
    );

}

const mapStateToProps = state => {
    return {
        app: state.app.qualifyVehicle,
        vehicle: state.qualifyVehicle.vehicle
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onNext: (data, nextStep) => dispatch(actions.saveQuestions(data)),
        onReset: () => dispatch(actions.resetQualifyVehicle()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step1);
